// Set 1B structural CYPE → L37 map.
// Codes and verdicts only. This module has no prices, no hourly rates,
// and no path from Autogrua (mq07gte* / mq04cag*) to EQ.BET.GRUA.

export const SET1B_SEED = "set1b_finishes_v1";

export type CypeL37Verdict = "REUSE" | "NEW" | "RULE_FIRST" | "NONE" | "EXCL";

export type Set1bResource = {
  categoryCode: string;
  code: string;
  name: string;
  resourceType: "material" | "labor" | "equipment";
  unit: string;
};

export const SET1B_RESOURCES: readonly Set1bResource[] = [
  { categoryCode: "MO", code: "MO.ISOLAMENTO", name: "Oficial montador de isolamentos", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.AJ.ISOLAMENTO", name: "Ajudante montador de isolamentos", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.PEDREIRO", name: "Oficial de construção / pedreiro", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.AJ.PEDREIRO", name: "Ajudante de construção / pedreiro", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.SERVENTE", name: "Operário não qualificado de construção", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.IMPER", name: "Oficial de impermeabilização", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.AJ.IMPER", name: "Ajudante de impermeabilização", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.LADRILHADOR", name: "Oficial ladrilhador", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.AJ.LADRILHADOR", name: "Ajudante de ladrilhador", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.PINTOR", name: "Oficial pintor", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.AJ.PINTOR", name: "Ajudante de pintor", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.REBOCADOR", name: "Oficial rebocador", resourceType: "labor", unit: "h" },
  { categoryCode: "MO", code: "MO.AJ.REBOCADOR", name: "Ajudante de rebocador", resourceType: "labor", unit: "h" },
  { categoryCode: "MAT.OBRA", code: "MAT.AGUA", name: "Água", resourceType: "material", unit: "m3" },
  { categoryCode: "MAT.OBRA", code: "MAT.AREIA.ARGAMASSA", name: "Areia de pedreira para argamassa preparada em obra", resourceType: "material", unit: "t" },
  { categoryCode: "MAT.OBRA", code: "MAT.CIM.CEM_II_B_L_32_5", name: "Cimento Portland CEM II/B-L 32,5 R", resourceType: "material", unit: "kg" },
  { categoryCode: "EQ", code: "EQ.BETONEIRA", name: "Betoneira eléctrica de 160 l", resourceType: "equipment", unit: "h" },
];

const SET1B_RESOURCE_CODES = new Set(SET1B_RESOURCES.map((resource) => resource.code));

export type CypeL37Mapping = {
  cypeCode: string;
  verdict: CypeL37Verdict;
  l37Code: string | null;
  quantityFusion: boolean;
  countsAsMappedResource: boolean;
  note: string;
};

type MapSeed = {
  cypeCode: string;
  verdict: CypeL37Verdict;
  l37Code: string | null;
  quantityFusion?: boolean;
  note: string;
};

const MAP_SEED: readonly MapSeed[] = [
  { cypeCode: "mo054", verdict: "NEW", l37Code: "MO.ISOLAMENTO", note: "Oficial montador de isolamentos. O aplicador mo030 funde neste código." },
  { cypeCode: "mo030", verdict: "NEW", l37Code: "MO.ISOLAMENTO", note: "Aplicador de produtos isolantes fundido em MO.ISOLAMENTO." },
  { cypeCode: "mo101", verdict: "NEW", l37Code: "MO.AJ.ISOLAMENTO", note: "Ajudante montador de isolamentos. O ajudante aplicador mo068 funde neste código." },
  { cypeCode: "mo068", verdict: "NEW", l37Code: "MO.AJ.ISOLAMENTO", note: "Ajudante aplicador de produtos isolantes fundido em MO.AJ.ISOLAMENTO." },
  { cypeCode: "mo020", verdict: "NEW", l37Code: "MO.PEDREIRO", note: "Oficial de 1a construção." },
  { cypeCode: "mo021", verdict: "NEW", l37Code: "MO.PEDREIRO", note: "Oficial auxiliar de pedreiro fundido em MO.PEDREIRO." },
  { cypeCode: "mo112", verdict: "NEW", l37Code: "MO.PEDREIRO", note: "Operário especializado sem código próprio; funde em MO.PEDREIRO." },
  { cypeCode: "mo077", verdict: "NEW", l37Code: "MO.AJ.PEDREIRO", note: "Ajudante de construção fundido em MO.AJ.PEDREIRO." },
  { cypeCode: "mo078", verdict: "NEW", l37Code: "MO.AJ.PEDREIRO", note: "Ajudante auxiliar de pedreiro fundido em MO.AJ.PEDREIRO." },
  { cypeCode: "mo113", verdict: "NEW", l37Code: "MO.SERVENTE", note: "Operário não qualificado de construção." },
  { cypeCode: "mo114", verdict: "NEW", l37Code: "MO.SERVENTE", note: "Operário não qualificado auxiliar fundido em MO.SERVENTE." },
  { cypeCode: "mo029", verdict: "NEW", l37Code: "MO.IMPER", note: "Oficial de lâminas impermeabilizantes fundido em MO.IMPER." },
  { cypeCode: "mo032", verdict: "NEW", l37Code: "MO.IMPER", note: "Oficial de produtos impermeabilizantes fundido em MO.IMPER." },
  { cypeCode: "mo067", verdict: "NEW", l37Code: "MO.AJ.IMPER", note: "Ajudante de lâminas fundido em MO.AJ.IMPER." },
  { cypeCode: "mo070", verdict: "NEW", l37Code: "MO.AJ.IMPER", note: "Ajudante de produtos impermeabilizantes fundido em MO.AJ.IMPER." },
  { cypeCode: "mo023", verdict: "NEW", l37Code: "MO.LADRILHADOR", note: "Oficial ladrilhador." },
  { cypeCode: "mo024", verdict: "NEW", l37Code: "MO.LADRILHADOR", note: "Azulejador fundido em MO.LADRILHADOR." },
  { cypeCode: "mo061", verdict: "NEW", l37Code: "MO.AJ.LADRILHADOR", note: "Ajudante de ladrilhador." },
  { cypeCode: "mo062", verdict: "NEW", l37Code: "MO.AJ.LADRILHADOR", note: "Ajudante azulejador fundido em MO.AJ.LADRILHADOR." },
  { cypeCode: "mo038", verdict: "NEW", l37Code: "MO.PINTOR", note: "Oficial pintor." },
  { cypeCode: "mo076", verdict: "NEW", l37Code: "MO.AJ.PINTOR", note: "Ajudante de pintor." },
  { cypeCode: "mo039", verdict: "NEW", l37Code: "MO.REBOCADOR", note: "Oficial rebocador." },
  { cypeCode: "mo111", verdict: "NEW", l37Code: "MO.REBOCADOR", note: "Operário especializado rebocador fundido em MO.REBOCADOR." },
  { cypeCode: "mo079", verdict: "NEW", l37Code: "MO.AJ.REBOCADOR", note: "Ajudante de rebocador." },
  { cypeCode: "mt08aaa010a", verdict: "NEW", l37Code: "MAT.AGUA", note: "Água de obra. Sem preço L37." },
  { cypeCode: "mt01arg005a", verdict: "NEW", l37Code: "MAT.AREIA.ARGAMASSA", note: "Areia de pedreira para argamassa em obra. Sem preço L37." },
  { cypeCode: "mt08cem011a", verdict: "NEW", l37Code: "MAT.CIM.CEM_II_B_L_32_5", note: "Cimento Portland CEM II/B-L 32,5 R. Sem preço L37." },
  { cypeCode: "mq06hor010", verdict: "NEW", l37Code: "EQ.BETONEIRA", note: "Betoneira 160 l. Não é bomba nem grua. Sem preço L37." },

  { cypeCode: "mo044", verdict: "REUSE", l37Code: "MO.COFRADOR", note: "Reutiliza MO.COFRADOR." },
  { cypeCode: "mo091", verdict: "REUSE", l37Code: "MO.AJ.COFRADOR", note: "Reutiliza MO.AJ.COFRADOR." },
  { cypeCode: "mo043", verdict: "REUSE", l37Code: "MO.ARMADOR", note: "Reutiliza MO.ARMADOR." },
  { cypeCode: "mo090", verdict: "REUSE", l37Code: "MO.AJ.ARMADOR", note: "Reutiliza MO.AJ.ARMADOR." },
  { cypeCode: "mo045", verdict: "REUSE", l37Code: "MO.BETONAGEM", note: "Reutiliza MO.BETONAGEM. Não existe MO.AJ.BETONAGEM." },
  { cypeCode: "mt10haf020bgngc", verdict: "REUSE", l37Code: "MAT.BET.C25_30", note: "Betão C25/30 de central. Exposição e consistência ficam fora do código." },
  { cypeCode: "mt07aco040e", verdict: "REUSE", l37Code: "MAT.ACO.A400NR", note: "Varão A400 NR em obra, sem elaboração." },
  { cypeCode: "mt08var050", verdict: "REUSE", l37Code: "MAT.ACO.ARAME", note: "Arame de atar." },
  { cypeCode: "mt08dba010b", verdict: "REUSE", l37Code: "MAT.COFR.DESCOFRANTE", note: "Descofrante. Em fichas BA a linha pode ser absorvida por A-lite; o PU CYPE não passa a preço L37." },

  { cypeCode: "mo092", verdict: "RULE_FIRST", l37Code: "MO.BETONAGEM", quantityFusion: true, note: "Funde a quantidade em MO.BETONAGEM. Não cria MO.AJ.BETONAGEM e não copia o PU horário CYPE." },
  { cypeCode: "mt07aco040b", verdict: "RULE_FIRST", l37Code: null, note: "Aço elaborado em fábrica. FB-NO para MAT.ACO.A400NR puro. Não inventar preço de SUB.ACO.CORTE_DOBRAGEM." },
  { cypeCode: "mt50spa081a", verdict: "RULE_FIRST", l37Code: null, note: "Escora amortizada em Ud. AUX.ESCORAMENTO é m2 de utilização. Regra C antes de preço." },
  { cypeCode: "mt50spa050m", verdict: "RULE_FIRST", l37Code: null, note: "Pranchão em m3, activo amortizado. A-lite ou FB-CONV; não copiar o PU de activo." },
  { cypeCode: "mt50spa052b", verdict: "RULE_FIRST", l37Code: null, note: "Pranchão linear. Unidade incompatível com m2 ou m3 de utilização." },
  { cypeCode: "mt08cim030b", verdict: "RULE_FIRST", l37Code: null, note: "Madeira de pinho muitas vezes absorvida por A-lite. Sem código MAT novo neste Set." },
  { cypeCode: "mt08var060", verdict: "RULE_FIRST", l37Code: null, note: "Pregos em contexto de cofragem amortizada. Sem código AUX novo neste Set." },

  { cypeCode: "mq07gte010c", verdict: "NONE", l37Code: null, note: "Autogrua. Não mapear para EQ.BET.GRUA." },
  { cypeCode: "mq07gte010b", verdict: "NONE", l37Code: null, note: "Autogrua. Não mapear para EQ.BET.GRUA." },
  { cypeCode: "mq07gte010a", verdict: "NONE", l37Code: null, note: "Autogrua. Não mapear para EQ.BET.GRUA." },
  { cypeCode: "mq04cag010a", verdict: "NONE", l37Code: null, note: "Camião com grua. Não mapear para EQ.BET.GRUA." },

  { cypeCode: "complement", verdict: "EXCL", l37Code: null, note: "Complemento percentual. Fora do PU seco L37." },
  { cypeCode: "auxiliary", verdict: "EXCL", l37Code: null, note: "Meios auxiliares. Percentagem sobre o custo direto. Fora do PU seco L37." },
  { cypeCode: "indirect", verdict: "EXCL", l37Code: null, note: "Custos indiretos. Percentagem sobre o subtotal após meios auxiliares. Fora do PU seco L37." },
];

function countsAsMappedResource(seed: MapSeed) {
  if (!seed.l37Code) return false;
  if (seed.verdict === "REUSE" || seed.verdict === "NEW") return true;
  return seed.verdict === "RULE_FIRST" && seed.quantityFusion === true && seed.l37Code === "MO.BETONAGEM";
}

export function isAutogruaCypeCode(cypeCode: string) {
  return cypeCode.startsWith("mq07gte") || cypeCode.startsWith("mq04cag");
}

function freeze(seed: MapSeed): CypeL37Mapping {
  const quantityFusion = seed.quantityFusion === true;
  return {
    cypeCode: seed.cypeCode,
    verdict: seed.verdict,
    l37Code: seed.l37Code,
    quantityFusion,
    countsAsMappedResource: countsAsMappedResource(seed),
    note: seed.note,
  };
}

export const CYPE_L37_MAP: readonly CypeL37Mapping[] = MAP_SEED.map(freeze);

const BY_CODE = new Map(CYPE_L37_MAP.map((row) => [row.cypeCode, row]));

for (const row of CYPE_L37_MAP) {
  if (row.l37Code === "EQ.BET.GRUA" || row.l37Code === "MO.AJ.BETONAGEM" || row.l37Code === "MO.ISOLAMENTOS" || row.l37Code === "MO.AJ.ISOLAMENTOS") {
    throw new Error("Código L37 proibido no mapa Set 1B: " + row.l37Code);
  }
  if (isAutogruaCypeCode(row.cypeCode) && (row.verdict !== "NONE" || row.l37Code !== null || row.countsAsMappedResource)) {
    throw new Error("Autogrua não pode mapear: " + row.cypeCode);
  }
  if (row.verdict === "NEW" && row.l37Code && !SET1B_RESOURCE_CODES.has(row.l37Code)) {
    throw new Error("NEW sem recurso Set 1B: " + row.cypeCode);
  }
  if ((row.verdict === "NONE" || row.verdict === "EXCL") && (row.l37Code !== null || row.quantityFusion)) {
    throw new Error("NONE/EXCL com alvo: " + row.cypeCode);
  }
}

const NONE_AUTOGUA: CypeL37Mapping = {
  cypeCode: "",
  verdict: "NONE",
  l37Code: null,
  quantityFusion: false,
  countsAsMappedResource: false,
  note: "Autogrua. Não mapear para EQ.BET.GRUA.",
};

export function resolveCypeCatalogueCode(cypeCode: string | null | undefined): CypeL37Mapping | null {
  if (!cypeCode) return null;
  if (isAutogruaCypeCode(cypeCode)) {
    return BY_CODE.get(cypeCode) ?? { ...NONE_AUTOGUA, cypeCode };
  }
  return BY_CODE.get(cypeCode) ?? null;
}

export type CatalogueFicha = {
  id: string;
  lines: readonly string[];
};

export type CatalogueCoverage = {
  fichaCount: number;
  mappedFichas: number;
  cypeOnlyFichas: number;
  gainedViaNewResource: number;
  reuseOrFusionOnly: number;
  unresolvedRuleFichas: number;
  unresolvedRuleWithoutMappedResource: number;
};

export function summarizeCatalogueCoverage(fichas: readonly CatalogueFicha[]): CatalogueCoverage {
  let mappedFichas = 0;
  let gainedViaNewResource = 0;
  let reuseOrFusionOnly = 0;
  let unresolvedRuleFichas = 0;
  let unresolvedRuleWithoutMappedResource = 0;
  for (const ficha of fichas) {
    let mapped = false;
    let viaNew = false;
    let unresolvedRule = false;
    const seen = new Set<string>();
    for (const code of ficha.lines) {
      if (!code || seen.has(code)) continue;
      seen.add(code);
      const row = resolveCypeCatalogueCode(code);
      if (!row || row.verdict === "EXCL") continue;
      if (row.countsAsMappedResource) {
        mapped = true;
        if (row.l37Code && SET1B_RESOURCE_CODES.has(row.l37Code)) viaNew = true;
      } else if (row.verdict === "RULE_FIRST") {
        unresolvedRule = true;
      }
    }
    if (mapped) mappedFichas += 1;
    if (viaNew) gainedViaNewResource += 1;
    if (mapped && !viaNew) reuseOrFusionOnly += 1;
    if (unresolvedRule) unresolvedRuleFichas += 1;
    if (unresolvedRule && !mapped) unresolvedRuleWithoutMappedResource += 1;
  }
  return {
    fichaCount: fichas.length,
    mappedFichas,
    cypeOnlyFichas: fichas.length - mappedFichas,
    gainedViaNewResource,
    reuseOrFusionOnly,
    unresolvedRuleFichas,
    unresolvedRuleWithoutMappedResource,
  };
}
